import styled, { Scale, Typography } from '@secretescapes/falcon';

export const TextContainer = styled('div')`
  padding: ${Scale.l} ${Scale.m};
  box-sizing: border-box;
  margin-bottom: ${Scale.xl};
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    margin-bottom: calc(${Scale.xl} + 1.25rem);
  }
`;

export const UnderlineTypography = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
`;

export const LabelWrapper = styled('div')`
  display: flex;
  gap: ${Scale.xxs};
  align-items: center;
  color: ${({ theme }) => theme.color.blackText};
  cursor: pointer;
`;

export const CloseButtonContainer = styled('div')`
  position: absolute;
  right: ${Scale.m};
  top: ${Scale.m};
  cursor: pointer;
`;

export const StyledDetailsContainer = styled('div')<{ isOpen: boolean }>`
  z-index: ${({ isOpen }) => (isOpen ? '99999' : '5')};
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
  overflow: scroll;

  top: 0;
  left: 0;

  opacity: ${({ isOpen }) => (isOpen ? '1' : '0.7')};
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '100%')});
  transition:
    transform 0.3s ease-in,
    opacity 0.3s ease-out;
`;

export const StyledHeader = styled('div')`
  margin-bottom: ${Scale.s};
`;

export const OverlayHeaderContainer = styled.div`
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.color.black};
  padding: calc(${Scale.xxxs} + ${Scale.xxs});
`;

export const StyledTypography = styled(Typography)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
